import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';

export interface IViewMedicalDossierPatientConsentAddValidated {
    episodeCategoryIds: string[];
    patientId: string;
}

const viewMedicalDossierPatientConsentAdd = Koi.object().keys({
    episodeCategoryIds: Koi.array().items(Koi.string().uuid()),
    patientId: Koi.string().uuid(),
});

// eslint-disable-next-line @stylistic/max-len
export const viewMedicalDossierPatientConsentAddSchema: ISchemaContainer<IViewMedicalDossierPatientConsentAddValidated> =
    {
        schema: viewMedicalDossierPatientConsentAdd.options({ convert: false, presence: 'required' }),
    };
